import React from 'react';
import { motion, useReducedMotion } from 'motion/react';

export const pageMotion = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.22,
      ease: 'easeOut',
      staggerChildren: 0.055,
      delayChildren: 0.04,
    },
  },
  exit: {
    opacity: 0,
    y: 8,
    transition: {
      duration: 0.16,
      ease: 'easeIn',
    },
  },
};

export const sectionMotion = {
  hidden: {
    opacity: 0,
    y: 18,
    filter: 'blur(2px)',
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: {
      duration: 0.28,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

export const metricMotion = {
  hidden: {
    opacity: 0,
    y: 14,
    scale: 0.98,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.24,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

export const AnimatedPage = ({ children }) => {
  const reduceMotion = useReducedMotion();

  return (
    <motion.div
      initial={reduceMotion ? false : 'hidden'}
      animate="visible"
      exit={reduceMotion ? undefined : 'exit'}
      variants={reduceMotion ? undefined : pageMotion}
      style={{ width: '100%' }}
    >
      {children}
    </motion.div>
  );
};

export const AnimatedSection = ({ children, variant = sectionMotion }) => {
  const reduceMotion = useReducedMotion();

  return (
    <motion.div
      variants={reduceMotion ? undefined : variant}
      style={{ height: '100%' }}
    >
      {children}
    </motion.div>
  );
};

export const AnimatedActionBar = ({ children }) => {
  const reduceMotion = useReducedMotion();

  return (
    <motion.div
      variants={reduceMotion ? undefined : sectionMotion}
      initial={reduceMotion ? false : undefined}
      animate={reduceMotion ? undefined : undefined}
    >
      {children}
    </motion.div>
  );
};
